import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import Layout from '../../shared/components/layout';
import { ScreenTable } from '../../shared/types';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider from '../../shared/context/GetAllColumnContext';
import { PartSearchContainer } from '../../features/part_search';
import { t } from '../../i18next';
import { useCallback, useState } from 'react';
import MultiHtzGrid from '../../features/part_search/components/MultiHtzGrid';
import MultiHtzCheckbox from '../../features/part_search/components/MultiHtzCheckbox';
import MultiHtzInput from '../../features/part_search/components/MultiHtzInput';

export default function PartSearchPage() {
  const { loading, screenTables }: { loading: boolean; screenTables: ScreenTable[] } =
    useFetchScreenDetails('part_search');
  const [multiHTZ, setMultiHtz] = useState(false);
  const [multiHTZInput, setMultiHtzInput] = useState('');
  const [selectedHTZValue, setSelectedHTZValue] = useState([]);

  const handleChangeHTZ = (e) => {
    const newChecked = e.target.checked;
    setMultiHtzInput('');
    setSelectedHTZValue([]);
    setMultiHtz(newChecked);
  };

  const handleMultiHtzSearch = useCallback(() => {
    const htzArrayRaw = multiHTZInput.split(',');
    const htzArray = htzArrayRaw.map((item) => item.trim()).filter((item) => item.length > 0);

    setSelectedHTZValue(htzArray);
  }, [multiHTZInput]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        handleMultiHtzSearch();
      }
    },
    [handleMultiHtzSearch],
  );

  if (loading) {
    return (
      <Layout>
        <Spinners />
      </Layout>
    );
  }

  if (!screenTables?.length) {
    return (
      <Layout>
        <Banner variant='warning'>{t('data_not_available')}</Banner>
      </Layout>
    );
  }

  const screenToDatagridId = screenTables[0].id;

  return (
    <Layout>
      <MultiHtzCheckbox handleChangeHTZ={handleChangeHTZ} />
      {multiHTZ && (
        <MultiHtzInput
          multiHTZInput={multiHTZInput}
          setMultiHtzInput={setMultiHtzInput}
          handleKeyDown={handleKeyDown}
          handleMultiHtzSearch={handleMultiHtzSearch}
        />
      )}
      <GetAllColumnContextProvider key={screenToDatagridId}>
        {!multiHTZ && <PartSearchContainer tableRes={screenTables[0]} />}
      </GetAllColumnContextProvider>

      <GetAllColumnContextProvider key={`${screenToDatagridId}-multihtz`}>
        <>
          {multiHTZ && selectedHTZValue.length > 0 && (
            <MultiHtzGrid tableRes={screenTables[0]} selectedHTZValue={selectedHTZValue} />
          )}
        </>
      </GetAllColumnContextProvider>
    </Layout>
  );
}
